import { apiUrl, api } from "../util";

export async function list(group: string, state: string[] = []) {
  return api({
    method: "GET",
    url: apiUrl(`/api/v2/auctions`),
    params: {
      group,
      state,
    },
  });
}

/** The auction, including the authenticated caller's own bids on it. */
export async function view(slug: string) {
  return api({
    method: "GET",
    url: apiUrl(`/api/v2/auctions/${slug}`),
  });
}

/** Place a bid. For low-bid auctions `amount` is the max price per unit. */
export async function bid(slug: string, amount: number, quantity: number) {
  return api({
    method: "POST",
    url: apiUrl(`/api/v2/auctions/${slug}/bid`),
    data: { amount, quantity },
  });
}

/** Cancel one of the current user's active bids on a low-bid auction. */
export async function cancelBid(slug: string, bidId: string) {
  return api({
    method: "DELETE",
    url: apiUrl(`/api/v2/auctions/${slug}/bids/${bidId}`),
  });
}

/** The auction plus the current user's bids on it. */
export async function getBids(slug: string) {
  return api({
    method: "GET",
    url: apiUrl(`/api/v2/auctions/${slug}/bids`),
  });
}

/** Every auction the current user has bid on, each with its `bids[]`. */
export async function getListings() {
  return api({
    method: "GET",
    url: apiUrl(`/api/v2/auctions/bids`),
  });
}
